import { get, last, range } from 'lodash-es';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';

export const MIN_MILE_VALUE = 25;
export const MAX_MILE_VALUE = 600;
export const STEP = 25;

export function getRangeValue({ vinData }) {
  const expectedRangeMin = get(vinData, 'thirdPartyInfo.recurrentInsights.expectedRange.min');
  const epaRange = get(vinData, 'vehicleInfo.partsInfo.electricityRange');
  const isNewVehicle = isNew(get(vinData, 'type'));

  return isNewVehicle ? epaRange : expectedRangeMin || epaRange;
}

export function getLowestIncr(rangeValue) {
  if (rangeValue < MIN_MILE_VALUE) return rangeValue;

  const miles = rangeValue > MAX_MILE_VALUE ? MAX_MILE_VALUE : rangeValue;
  const counts = range(MIN_MILE_VALUE, miles + 1, STEP);
  return last(counts);
}

export function getMilesValue({ vinData }) {
  const rangeValue = getRangeValue({ vinData });
  return getLowestIncr(rangeValue);
}
